import {useIntl} from 'react-intl'
import useGlobalFields from './useGlobalFields'
import {useMemo} from 'react'

const usePressContactFormFields = ({form, prefix = '', countries}) => {
    const {formatMessage} = useIntl()
    const {
        control,
        formState: {errors}
    } = form
    const {email} = useGlobalFields({form, prefix})

    const {locale} = useIntl()

    const currentCountry = useMemo(() => {
        let currentCode = locale.split('-')[1]

        if (currentCode === 'GB') {
            currentCode = 'UK'
        }

        return countries.find(({code}) => code === currentCode)
    }, [countries, locale])

    const fields = {
        country: {
            name: `${prefix}country`,
            label: formatMessage({
                defaultMessage: 'Country',
                id: 'use_address_fields.label.country'
            }),
            type: 'select',
            defaultValue: currentCountry ? currentCountry.code : '',
            options: countries.map(({code, label}) => ({value: code, label})),
            isRequired: true,
            control
        },
        email: {
            ...email
        },
        subject: {
            name: `${prefix}subject`,
            label: formatMessage({
                defaultMessage: 'Subject',
                id: 'customer_service.contactform.subject'
            }),
            type: 'text',
            defaultValue: '',
            inputProps: {
                autoComplete: 'off'
            },
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your subject.',
                    id: 'customer_service.contactform.required_subject'
                })
            },
            error: errors[`${prefix}subject`],
            control
        },
        message: {
            name: `${prefix}message`,
            label: formatMessage({
                defaultMessage: 'Message',
                id: 'customer_service.contactform.message'
            }),
            type: 'textarea',
            defaultValue: '',
            inputProps: {
                autoComplete: 'off'
            },
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your message.',
                    id: 'customer_service.contactform.required_message'
                })
            },
            error: errors[`${prefix}message`],
            control
        }
    }

    return fields
}

export default usePressContactFormFields
